import { render } from "./flats-crm-filter-desctop.vue?vue&type=template&id=4be26825"
import script from "./flats-crm-filter-desctop.vue?vue&type=script&lang=js"
export * from "./flats-crm-filter-desctop.vue?vue&type=script&lang=js"

import "./flats-crm-filter-desctop.vue?vue&type=style&index=0&id=4be26825&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__